import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-socios-negocio',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './socios-negocio.template.component.html',
  styleUrls: ['./socios-negocio.template.component.scss']
})
export class SkeletorSociosNegocioTemplateComponent {
  @Input() items: number = 8;
  get rows() { return Array.from({ length: this.items }); }
}

